var appWords = {};
var mappings = null;
var defaults = null;
export default class TextMap {
  constructor() {

    if (!mappings) {
      this.createMappings();
    }
    if (!defaults) {
      this.createDefaults();
    }
  }

  reset() {
    appWords = {};
  }

  createMappings() {
    mappings = {};
    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name != 'mappings' && name != 'defaults' && !(this[name] instanceof Function)) {
        if (!mappings[name]) {
          mappings[name] = {};
        }
        mappings[name] = name;
      }
    }

  }

  createDefaults() {
    defaults = {};
    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name != 'mappings' && name != 'defaults' && !(this[name] instanceof Function)) {
        if (!defaults[name]) {
          defaults[name] = {};
        }
        defaults[name] = this[name];
      }
    }

  }
  
  get mappings() {
    return mappings;
  }

  get defaults() {
    return defaults;
  }

  set company(s) {
    appWords.company = s;
  }
  get company() {
    return appWords.company ? appWords.company : 'Company';
  }
  set companyDetail(s) {
    appWords.companyDetail = s;
  }
  get companyDetail() {
    return appWords.companyDetail ? appWords.companyDetail : 'Company Detail';
  }
  set companies(s) {
    appWords.companies = s;
  }
  get companies() {
    return appWords.companies ? appWords.companies : 'Companies';
  }
  set assignCompanies(s) {
    appWords.assignCompanies = s;
  }
  get assignCompanies() {
    return appWords.assignCompanies ? appWords.assignCompanies : 'Assign Companies';
  }
  set companyName(s) {
    appWords.companyName = s;
  }
  get companyName() {
    return appWords.companyName ? appWords.companyName : 'Company Name';
  }
  set byCompany(s) {
    appWords.byCompany = s;
  }
  get byCompany() {
    return appWords.byCompany ? appWords.byCompany : 'By Company';
  }
  set switchCompany(s) {
    appWords.switchCompany = s;
  }
  get switchCompany() {
    return appWords.switchCompany ? appWords.switchCompany : 'Switch Company';
  }
  set selectCompany(s) {
    appWords.selectCompany = s;
  }
  get selectCompany() {
    return appWords.selectCompany ? appWords.selectCompany : 'Select Company';
  }
  set companyInformation(s) {
    appWords.companyInformation = s;
  }
  get companyInformation() {
    return appWords.companyInformation ? appWords.companyInformation : 'COMPANY INFORMATION';
  }
  set companyContact(s) {
    appWords.companyContact = s;
  }
  get companyContact() {
    return appWords.companyContact ? appWords.companyContact : 'COMPANY CONTACT';
  }
  set companyAdmin(s) {
    appWords.companyAdmin = s;
  }
  get companyAdmin() {
    return appWords.companyAdmin ? appWords.companyAdmin : 'PRIMARY COMPANY ADMIN';
  }
  set companyCustomization(s) {
    appWords.companyCustomization = s;
  }
  get companyCustomization() {
    return appWords.companyCustomization ? appWords.companyCustomization : 'COMPANY CUSTOMIZATION';
  }
  set companyContactFooter(s) {
    appWords.companyContactFooter = s;
  }
  get companyContactFooter() {
    return appWords.companyContactFooter ? appWords.companyContactFooter : '*Person in charge of account (will be added as user)';
  }
  set companyAdminFooter(s) {
    appWords.companyAdminFooter = s;
  }
  get companyAdminFooter() {
    return appWords.companyAdminFooter ? appWords.companyAdminFooter : '*Person in charge of administering the company (will be added as user)';
  }
  set editCompany(s) {
    appWords.editCompany = s;
  }
  get editCompany() {
    return appWords.editCompany ? appWords.editCompany : 'Edit';
  }
  set createCompany(s) {
    appWords.createCompany = s;
  }
  get createCompany() {
    return appWords.createCompany ? appWords.createCompany : 'Create Company';
  }
  set companyNameRequired(s) {
    appWords.companyNameRequired = s;
  }
  get companyNameRequired() {
    return appWords.companyNameRequired ? appWords.companyNameRequired : 'Company name is required';
  }
  set companyArchiveQuestion(s) {
    appWords.companyArchiveQuestion = s;
  }
  get companyArchiveQuestion() {
    return appWords.companyArchiveQuestion ? appWords.companyArchiveQuestion : 'Are you sure you want to delete this company? Doing so will delete all project types, directories, users, projects, builds, and tasks associated with it.';
  }
  set deleteCompany(s) {
    appWords.deleteCompany = s;
  }
  get deleteCompany() {
    return appWords.deleteCompany ? appWords.deleteCompany : 'Delete';
  }
  set adminCompany(s) {
    appWords.adminCompany = s;
  }
  get adminCompany() {
    return appWords.adminCompany ? appWords.adminCompany : 'Super Company';
  }
  set newCompany(s) {
    appWords.newCompany = s;
  }
  get newCompany() {
    return appWords.newCompany ? appWords.newCompany : 'New Company';
  }
  set noCompanyErrorMessage(s) {
    appWords.noCompanyErrorMessage = s;
  }
  get noCompanyErrorMessage() {
    return appWords.noCompanyErrorMessage ? appWords.noCompanyErrorMessage : 'At least one company must be assigned to the project before you can activate the project.';
  }
  set primaryCompany(s) {
    appWords.primaryCompany = s;
  }
  get primaryCompany() {
    return appWords.primaryCompany ? appWords.primaryCompany : 'Primary Company';
  }
  set editWhiteLabels(s) {
    appWords.editWhiteLabels = s;
  }
  get editWhiteLabels() {
    return appWords.editWhiteLabels ? appWords.editWhiteLabels : 'Edit Company White Labels';
  }
  set region(s) {
    appWords.region = s;
  }
  get region() {
    return appWords.region ? appWords.region : 'Region';
  }
  set regions(s) {
    appWords.regions = s;
  }
  get regions() {
    return appWords.regions ? appWords.regions : 'Regions';
  }
  set byRegion(s) {
    appWords.byRegion = s;
  }
  get byRegion() {
    return appWords.byRegion ? appWords.byRegion : 'By Region';
  }
  set subRegion(s) {
    appWords.subRegion = s;
  }
  get subRegion() {
    return appWords.subRegion ? appWords.subRegion : 'Sub Region';
  }
  set subRegions(s) {
    appWords.subRegions = s;
  }
  get subRegions() {
    return appWords.subRegions ? appWords.subRegions : 'Sub Regions';
  }
  set allRegions(s) {
    appWords.allRegions = s;
  }
  get allRegions() {
    return appWords.allRegions ? appWords.allRegions : 'All Regions';
  }
  set editRegion(s) {
    appWords.editRegion = s;
  }
  get editRegion() {
    return appWords.editRegion ? appWords.editRegion : 'Edit';
  }
  set createRegion(s) {
    appWords.createRegion = s;
  }
  get createRegion() {
    return appWords.createRegion ? appWords.createRegion : 'Create Region';
  }
  set manageRegions(s) {
    appWords.manageRegions = s;
  }
  get manageRegions() {
    return appWords.manageRegions ? appWords.manageRegions : 'Manage Regions';
  }
  set newRegion(s) {
    appWords.newRegion = s;
  }
  get newRegion() {
    return appWords.newRegion ? appWords.newRegion : 'New Region';
  }
  set noRegionAssigned(s) {
    appWords.noRegionAssigned = s;
  }
  get noRegionAssigned() {
    return appWords.noRegionAssigned ? appWords.noRegionAssigned : 'No Region Assigned';
  }
  set regionInformation(s) {
    appWords.regionInformation = s;
  }
  get regionInformation() {
    return appWords.regionInformation ? appWords.regionInformation : 'Region Information';
  }
  set createSubRegion(s) {
    appWords.createSubRegion = s;
  }
  get createSubRegion() {
    return appWords.createSubRegion ? appWords.createSubRegion : 'Create Subregion';
  }
  set needRegionError(s) {
    appWords.needRegionError = s;
  }
  get needRegionError() {
    return appWords.needRegionError ? appWords.needRegionError : 'You must first select a region for the location.';
  }
  set projectType(s) {
    appWords.projectType = s;
  }
  get projectType() {
    return appWords.projectType ? appWords.projectType : 'Project Type';
  }
  set projectTypeAndTemplates(s) {
    appWords.projectTypeAndTemplates = s;
  }
  get projectTypeAndTemplates() {
    return appWords.projectTypeAndTemplates ? appWords.projectTypeAndTemplates : 'Project Types and Templates';
  }
  set projectTypes(s) {
    appWords.projectTypes = s;
  }
  get projectTypes() {
    return appWords.projectTypes ? appWords.projectTypes : 'Project Types';
  }
  set allProjectTypes(s) {
    appWords.allProjectTypes = s;
  }
  get allProjectTypes() {
    return appWords.allProjectTypes ? appWords.allProjectTypes : 'All Project Types';
  }
  set byProjectType(s) {
    appWords.byProjectType = s;
  }
  get byProjectType() {
    return appWords.byProjectType ? appWords.byProjectType : 'By Project Type';
  }
  set editProjectType(s) {
    appWords.editProjectType = s;
  }
  get editProjectType() {
    return appWords.editProjectType ? appWords.editProjectType : 'Edit';
  }
  set deleteProjectType(s) {
    appWords.deleteProjectType = s;
  }
  get deleteProjectType() {
    return appWords.deleteProjectType ? appWords.deleteProjectType : 'Delete';
  }
  set ProjectTypeTypeNameRequired(s) {
    appWords.ProjectTypeTypeNameRequired = s;
  }
  get ProjectTypeTypeNameRequired() {
    return appWords.ProjectTypeTypeNameRequired ? appWords.ProjectTypeTypeNameRequired : 'The Project Type must have a name.';
  }
  set projectTypeArchiveQuestion(s) {
    appWords.projectTypeArchiveQuestion = s;
  }
  get projectTypeArchiveQuestion() {
    return appWords.projectTypeArchiveQuestion ? appWords.projectTypeArchiveQuestion : 'Are you sure you want to delete this project type?';
  }
  set projectTemplateArchiveQuestion(s) {
    appWords.projectTemplateArchiveQuestion = s;
  }
  get projectTemplateArchiveQuestion() {
    return appWords.projectTemplateArchiveQuestion ? appWords.projectTemplateArchiveQuestion : 'Are you sure you want to delete this project template?';
  }
  set projectTemplateRefetchStaleData(s) {
    appWords.projectTemplateArchiveQuestion = s;
  }
  get projectTemplateRefetchStaleData() {
    return appWords.projectTemplateRefetchStaleData ? appWords.projectTemplateRefetchStaleData : 'This template does not exist. Please reload the page to get the get the latest data.';
  }
  set projectTypeWithNameAlreadyExists(s) {
    appWords.projectTypeWithNameAlreadyExists = s;
  }
  get projectTypeWithNameAlreadyExists() {
    return appWords.projectTypeWithNameAlreadyExists ? appWords.projectTypeWithNameAlreadyExists : 'A project type with that name already exists.';
  }
  set locationArchiveQuestion(s) {
    appWords.locationArchiveQuestion = s;
  }
  get locationArchiveQuestion() {
    return appWords.locationArchiveQuestion ? appWords.locationArchiveQuestion : 'Are you sure you want to delete this location?';
  }
  set deleteLocation(s) {
    appWords.deleteLocation = s;
  }
  get deleteLocation() {
    return appWords.deleteLocation ? appWords.deleteLocation : 'Delete';
  }
  set createProjectType(s) {
    appWords.createProjectType = s;
  }
  get createProjectType() {
    return appWords.createProjectType ? appWords.createProjectType : 'Create Project Type';
  }
  set newProjectType(s) {
    appWords.newProjectType = s;
  }
  get newProjectType() {
    return appWords.newProjectType ? appWords.newProjectType : 'New Project Type';
  }
  set enterNewProjectTypeName(s) {
    appWords.enterNewProjectTypeName = s;
  }
  get enterNewProjectTypeName() {
    return appWords.enterNewProjectTypeName ? appWords.enterNewProjectTypeName : 'Enter Project Type Name';
  }
  set manageProjectTypes(s) {
    appWords.manageProjectTypes = s;
  }
  get manageProjectTypes() {
    return appWords.manageProjectTypes ? appWords.manageProjectTypes : 'Manage Project Types';
  }
  set noProjectTypesAssigned(s) {
    appWords.noProjectTypesAssigned = s;
  }
  get noProjectTypesAssigned() {
    return appWords.noProjectTypesAssigned ? appWords.noProjectTypesAssigned : 'No Project Type Assigned';
  }
  set planOfRecord(s) {
    appWords.planOfRecord = s;
  }
  get planOfRecord() {
    return appWords.planOfRecord ? appWords.planOfRecord : 'Plan Of Record';
  }
  set location(s) {
    appWords.location = s;
  }
  get location() {
    return appWords.location ? appWords.location : 'Location';
  }
  set locations(s) {
    appWords.locations = s;
  }
  get locations() {
    return appWords.locations ? appWords.locations : 'Locations';
  }
  set newLocation(s) {
    appWords.newLocation = s;
  }
  get newLocation() {
    return appWords.newLocation ? appWords.newLocation : 'New Location';
  }
  set editLocation(s) {
    appWords.editLocation = s;
  }
  get editLocation() {
    return appWords.editLocation ? appWords.editLocation : 'Edit';
  }
  set createLocation(s) {
    appWords.createLocation = s;
  }
  get createLocation() {
    return appWords.createLocation ? appWords.createLocation : 'Create Location';
  }
  set nameLocation(s) {
    appWords.nameLocation = s;
  }
  get nameLocation() {
    return appWords.nameLocation ? appWords.nameLocation : 'Name & Location';
  }
  set noLocationErrorMessage(s) {
    appWords.noLocationErrorMessage = s;
  }
  get noLocationErrorMessage() {
    return appWords.noLocationErrorMessage ? appWords.noLocationErrorMessage : 'At location must be assigned to the project before you can activate the project.';
  }
  set projectLocation(s) {
    appWords.projectLocation = s;
  }
  get projectLocation() {
    return appWords.projectLocation ? appWords.projectLocation : 'Project Location';
  }
  set siteName(s) {
    appWords.siteName = s;
  }
  get siteName() {
    return appWords.siteName ? appWords.siteName : 'Site Name';
  }
  set customer(s) {
    appWords.customer = s;
  }
  get customer() {
    return appWords.customer ? appWords.customer : 'Customer';
  }
  set guid(s) {
    appWords.guid = s;
  }
  get guid() {
    return appWords.guid ? appWords.guid : 'Guid';
  }
  set locationNotes(s) {
    appWords.locationNotes = s;
  }
  get locationNotes() {
    return appWords.locationNotes ? appWords.locationNotes : 'Location Notes';
  }
  set projectNotes(s) {
    appWords.projectNotes = s;
  }
  get projectNotes() {
    return appWords.projectNotes ? appWords.projectNotes : 'Project Notes';
  }
  set addLocation(s) {
    appWords.addLocation = s;
  }
  get addLocation() {
    return appWords.addLocation ? appWords.addLocation : '--Add Location--';
  }
  set noLocationAssigned(s) {
    appWords.noLocationAssigned = s;
  }
  get noLocationAssigned() {
    return appWords.noLocationAssigned ? appWords.noLocationAssigned : 'No Location Assigned';
  }
  set locationInformation(s) {
    appWords.locationInformation = s;
  }
  get locationInformation() {
    return appWords.locationInformation ? appWords.locationInformation : 'Location Information';
  }
  set build(s) {
    appWords.build = s;
  }
  get build() {
    return appWords.build ? appWords.build : 'Build';
  }
  set builds(s) {
    appWords.builds = s;
  }
  get builds() {
    return appWords.builds ? appWords.builds : 'Builds';
  }
  set deleteBuild(s) {
    appWords.deleteBuild = s;
  }
  get deleteBuild() {
    return appWords.deleteBuild ? appWords.deleteBuild : 'Delete';
  }
  set buildDeleteQuestion(s) {
    appWords.buildDeleteQuestion = s;
  }
  get buildDeleteQuestion() {
    return appWords.buildDeleteQuestion ? appWords.buildDeleteQuestion : 'Are you sure you want to delete this build? Doing so will delete all builds and tasks associated with it.';
  }
  set editBuild(s) {
    appWords.editBuild = s;
  }
  get editBuild() {
    return appWords.editBuild ? appWords.editBuild : 'Edit';
  }
  set createBuild(s) {
    appWords.createBuild = s;
  }
  get createBuild() {
    return appWords.createBuild ? appWords.createBuild : 'Create Build';
  }
  set buildInformation(s) {
    appWords.buildInformation = s;
  }
  get buildInformation() {
    return appWords.buildInformation ? appWords.buildInformation : 'Build Information';
  }
  set projects(s) {
    appWords.projects = s;
  }
  get projects() {
    return appWords.projects ? appWords.projects : 'Projects';
  }
  set project(s) {
    appWords.project = s;
  }
  get project() {
    return appWords.project ? appWords.project : 'Project';
  }
  set addProjectMember(s) {
    appWords.addProjectMember = s;
  }
  get addProjectMember() {
    return appWords.addProjectMember ? appWords.addProjectMember : 'Add Project Members';
  }
  set selectMember(s) {
    appWords.selectMember = s;
  }
  get selectMember() {
    return appWords.selectMember ? appWords.selectMember : 'Available Users';
  }
  set selectedMember(s) {
    appWords.selectedMember = s;
  }
  get selectedMember() {
    return appWords.selectedMember ? appWords.selectedMember : 'Project Members';
  }
  set addMember(s) {
    appWords.addMember = s;
  }
  get addMember() {
    return appWords.addMember ? appWords.addMember : 'Update Assigned Members';
  }
  set selectVendorCompany(s) {
    appWords.selectVendorCompany = s;
  }
  get selectVendorCompany() {
    return appWords.selectVendorCompany ? appWords.selectVendorCompany : 'Select Vendor Company';
  }
  set searchCompany(s) {
    appWords.searchCompany = s;
  }
  get searchCompany() {
    return appWords.searchCompany ? appWords.searchCompany : 'Search Companies';
  }
  set vendorArchiveQuestion(s) {
    appWords.vendorArchiveQuestion = s;
  }
  get vendorArchiveQuestion() {
    return appWords.vendorArchiveQuestion ? appWords.vendorArchiveQuestion : 'Are you sure you want to remove this user as a vendor?';
  }
  get projectGroupName() {
    return appWords.projectGroupName ? appWords.projectGroupName : 'Project Group Name';
  }
  set searchProject(s) {
    appWords.searchProject = s;
  }
  get searchProject() {
    return appWords.searchProject ? appWords.searchProject : 'Search Projects';
  }
  get searchAvailableProjects() {
    return appWords.searchAvailableProjects ? appWords.searchAvailableProjects : 'Search Available Projects';
  }
  get searchProjectTypes() {
    return appWords.searchProject ? appWords.searchProject : 'Search Project Types';
  }
  set searchLocation(s) {
    appWords.searchLocation = s;
  }
  get searchLocation() {
    return appWords.searchLocation ? appWords.searchLocation : 'Search Locations';
  }
  set searchReport(s) {
    appWords.searchReport = s;
  }
  get searchReport() {
    return appWords.searchReport ? appWords.searchReport : 'Search Report';
  }
  set filterProject(s) {
    appWords.filterProject = s;
  }
  get filterProject() {
    return appWords.filterProject ? appWords.filterProject : 'Filter Projects';
  }
  set byProjectManager(s) {
    appWords.byProjectManager = s;
  }
  get byProjectManager() {
    return appWords.byProjectManager ? appWords.byProjectManager : 'By Project Manager';
  }
  set allProjects(s) {
    appWords.allProjects = s;
  }
  get allProjects() {
    return appWords.allProjects ? appWords.allProjects : 'All Projects';
  }
  set activeProjects(s) {
    appWords.activeProjects = s;
  }
  get activeProjects() {
    return appWords.activeProjects ? appWords.activeProjects : 'Active Projects';
  }
  set publishedProjects(s) {
    appWords.publishedProjects = s;
  }
  get publishedProjects() {
    return appWords.publishedProjects ? appWords.publishedProjects : 'Published Projects';
  }
  set archivedProjects(s) {
    appWords.archivedProjects = s;
  }
  get archivedProjects() {
    return appWords.archivedProjects ? appWords.archivedProjects : 'Archived Projects';
  }
  set assignedProjects(s) {
    appWords.assignedProjects = s;
  }
  get assignedProjects() {
    return appWords.assignedProjects ? appWords.assignedProjects : 'Assigned Projects';
  }
  set projectCompletion(s) {
    appWords.projectCompletion = s;
  }
  get projectCompletion() {
    return appWords.projectCompletion ? appWords.projectCompletion : 'Project Completion';
  }
  set projectUpdateSuccess(s) {
    appWords.projectUpdateSuccess = s;
  }
  get projectUpdateSuccess() {
    return appWords.projectUpdateSuccess ? appWords.projectUpdateSuccess : 'The project has been successfully updated.';
  }
  set projectCreateSuccess(s) {
    appWords.projectCreateSuccess = s;
  }
  get projectCreateSuccess() {
    return appWords.projectCreateSuccess ? appWords.projectCreateSuccess : 'The project has been successfully created.';
  }
  set projectArchiveQuestion(s) {
    appWords.projectArchiveQuestion = s;
  }
  get projectArchiveQuestion() {
    return appWords.projectArchiveQuestion ? appWords.projectArchiveQuestion : 'Are you sure you want to delete this project? Doing so will delete all builds and tasks associated with it.';
  }
  set projectSettingArchiveQuestion(s) {
    appWords.projectSettingArchiveQuestion = s;
  }
  get projectSettingArchiveQuestion() {
    return appWords.projectSettingArchiveQuestion ? appWords.projectSettingArchiveQuestion : 'Are you sure you want to delete this custom field?';
  }
  set projectSwitchCompanyQuestion(s) {
    appWords.projectSwitchCompanyQuestion = s;
  }
  get projectSwitchCompanyQuestion() {
    return appWords.projectSwitchCompanyQuestion ? appWords.projectSwitchCompanyQuestion :
      'You are moving the project to the selected company. It will disappear from this view. Would you like to switch to the selected company view?';
  }
  set newProject(s) {
    appWords.newProject = s;
  }
  get newProject() {
    return appWords.newProject ? appWords.newProject : 'New Project';
  }
  set addNewProjectComment(s) {
    appWords.addNewProjectComment = s;
  }
  get addNewProjectComment() {
    return appWords.addNewProjectComment ? appWords.addNewProjectComment : 'Add New Project Comment';
  }
  set projectNameRequired(s) {
    appWords.projectNameRequired = s;
  }
  get projectNameRequired() {
    return appWords.projectNameRequired ? appWords.projectNameRequired : 'A project name is required.';
  }
  set locationNameRequired(s) {
    appWords.locationNameRequired = s;
  }
  get locationNameRequired() {
    return appWords.locationNameRequired ? appWords.locationNameRequired : 'A location name is required.';
  }
  set ProjectTypeNameRequired(s) {
    appWords.ProjectTypeNameRequired = s;
  }
  get ProjectTypeNameRequired() {
    return appWords.ProjectTypeNameRequired ? appWords.ProjectTypeNameRequired : 'A project type name is required.';
  }
  set noPMErrorMessage(s) {
    appWords.noPMErrorMessage = s;
  }
  get noPMErrorMessage() {
    return appWords.noPMErrorMessage ? appWords.noPMErrorMessage : 'A Project Manager must be assigned before you can activate the project.';
  }
  set projectSuccessfullyStartedMessage(s) {
    appWords.projectSuccessfullyStartedMessage = s;
  }
  get projectSuccessfullyStartedMessage() {
    return appWords.projectSuccessfullyStartedMessage ? appWords.projectSuccessfullyStartedMessage : 'The project has been successfully activated.';
  }
  set editProject(s) {
    appWords.editProject = s;
  }
  get editProject() {
    return appWords.editProject ? appWords.editProject : 'Edit';
  }
  set createProject(s) {
    appWords.createProject = s;
  }
  get createProject() {
    return appWords.createProject ? appWords.createProject : 'Create Project';
  }
  set deleteProject(s) {
    appWords.deleteProject = s;
  }
  get deleteProject() {
    return appWords.deleteProject ? appWords.deleteProject : 'Delete';
  }
  set activateProject(s) {
    appWords.activateProject = s;
  }
  get activateProject() {
    return appWords.activateProject ? appWords.activateProject : 'Activate Project';
  }
  set cancelProject(s) {
    appWords.cancelProject = s;
  }
  get cancelProject() {
    return appWords.cancelProject ? appWords.cancelProject : 'Cancel Project';
  }
  set pauseProject(s) {
    appWords.pauseProject = s;
  }
  get pauseProject() {
    return appWords.pauseProject ? appWords.pauseProject : 'Pause Project';
  }
  set resumeProject(s) {
    appWords.resumeProject = s;
  }
  get resumeProject() {
    return appWords.resumeProject ? appWords.resumeProject : 'Resume Project';
  }
  set projectInformation(s) {
    appWords.projectInformation = s;
  }
  get projectInformation() {
    return appWords.projectInformation ? appWords.projectInformation : 'Project Information';
  }
  set projectDatesAndManagement(s) {
    appWords.projectDatesAndManagement = s;
  }
  get projectDatesAndManagement() {
    return appWords.projectDatesAndManagement ? appWords.projectDatesAndManagement : 'Project Dates & Management';
  }
  set projectCustomFields(s) {
    appWords.projectCustomFields = s;
  }
  get projectCustomFields() {
    return appWords.projectCustomFields ? appWords.projectCustomFields : 'Project Custom Fields';
  }
  set fieldType(s) {
    appWords.fieldType = s;
  }
  get fieldType() {
    return appWords.fieldType ? appWords.fieldType : 'Custom Field Type';
  }
  set fieldLabel(s) {
    appWords.fieldLabel = s;
  }
  get fieldLabel() {
    return appWords.fieldLabel ? appWords.fieldLabel : 'Field Label';
  }
  set addNewSetting(s) {
    appWords.addNewSetting = s;
  }
  get addNewSetting() {
    return appWords.addNewSetting ? appWords.addNewSetting : 'Add Custom Field';
  }
  set projectTemplate(s) {
    appWords.projectTemplate = s;
  }
  get projectTemplate() {
    return appWords.projectTemplate ? appWords.projectTemplate : 'Project Template';
  }
  set projectTemplates(s) {
    appWords.projectTemplates = s;
  }
  get projectTemplates() {
    return appWords.projectTemplates ? appWords.projectTemplates : 'Project Templates';
  }
  set activeProject(s) {
    appWords.activeProject = s;
  }
  get activeProject() {
    return appWords.activeProject ? appWords.activeProject : 'Active Project';
  }
  set projectManager(s) {
    appWords.projectManager = s;
  }
  get projectManager() {
    return appWords.projectManager ? appWords.projectManager : 'Project Manager';
  }
  set projectMembers(s) {
    appWords.projectMembers = s;
  }
  get projectMembers() {
    return appWords.projectMembers ? appWords.projectMembers : 'Project Members';
  }
  set copyProject(s) {
    appWords.copyProject = s;
  }
  get copyProject() {
    return appWords.copyProject ? appWords.copyProject : 'Copy Project';
  }
  set cloneProject(s) {
    appWords.cloneProject = s;
  }
  get cloneProject() {
    return appWords.cloneProject ? appWords.cloneProject : 'Clone to Active Project';
  }
  set copyAsTemplate(s) {
    appWords.copyAsTemplate = s;
  }
  get copyAsTemplate() {
    return appWords.copyAsTemplate ? appWords.copyAsTemplate : 'Copy as Project Template';
  }
  set project_manager(s) {
    appWords.project_manager = s;
  }
  get project_manager() {
    return appWords.project_manager ? appWords.project_manager : 'PM';
  }
  set noPMAssigned(s) {
    appWords.noPMAssigned = s;
  }
  get noPMAssigned() {
    return appWords.noPMAssigned ? appWords.noPMAssigned : 'No PM Assigned';
  }
  set byProject(s) {
    appWords.byProject = s;
  }
  get byProject() {
    return appWords.byProject ? appWords.byProject : 'By Project';
  }
  set projectHierarchy(s) {
    appWords.projectHierarchy = s;
  }
  get projectHierarchy() {
    return appWords.projectHierarchy ? appWords.projectHierarchy : 'Project Hierarchy';
  }
  set task(s) {
    appWords.task = s;
  }
  get task() {
    return appWords.task ? appWords.task : 'Task';
  }
  set tasks(s) {
    appWords.tasks = s;
  }
  get tasks() {
    return appWords.tasks ? appWords.tasks : 'Tasks';
  }
  set myTasks(s) {
    appWords.myTasks = s;
  }
  get myTasks() {
    return appWords.myTasks ? appWords.myTasks : 'My Tasks';
  }
  set myTasksOnly(s) {
    appWords.myTasksOnly = s;
  }
  get myTasksOnly() {
    return appWords.myTasksOnly ? appWords.myTasksOnly : 'My Tasks Only';
  }
  set saveTask(s) {
    appWords.saveTask = s;
  }
  get saveTask() {
    return appWords.saveTask ? appWords.saveTask : 'Save Task';
  }
  set settings(s) {
    appWords.settings = s;
  }
  get settings() {
    return appWords.settings ? appWords.settings : 'Settings';
  }
  set deleteTask(s) {
    appWords.deleteTask = s;
  }
  get deleteTask() {
    return appWords.deleteTask ? appWords.deleteTask : 'Delete';
  }
  set taskArchiveQuestion(s) {
    appWords.taskArchiveQuestion = s;
  }
  get taskArchiveQuestion() {
    return appWords.taskArchiveQuestion ? appWords.taskArchiveQuestion : 'Are you sure you want to delete this task? Doing so will delete all completion steps and other info associated with it.';
  }
  set editTask(s) {
    appWords.editTask = s;
  }
  get editTask() {
    return appWords.editTask ? appWords.editTask : 'Edit';
  }
  set createTask(s) {
    appWords.createTask = s;
  }
  get createTask() {
    return appWords.createTask ? appWords.createTask : 'Add Task';
  }
  set taskSettings(s) {
    appWords.taskSettings = s;
  }
  get taskSettings() {
    return appWords.taskSettings ? appWords.taskSettings : 'Task Settings';
  }  
  set taskDetails(s) {
    appWords.taskDetails = s;
  }
  get taskDetails() {
    return appWords.taskDetails ? appWords.taskDetails : 'Task Details';
  }
  set addNewTaskComment(s) {
    appWords.addNewTaskComment = s;
  }
  get addNewTaskComment() {
    return appWords.addNewTaskComment ? appWords.addNewTaskComment : 'Add New Task Comment';
  }
  set markTaskComplete(s) {
    appWords.markTaskComplete = s;
  }
  get markTaskComplete() {
    return appWords.markTaskComplete ? appWords.markTaskComplete : 'Mark Task Complete';
  }
  set markTaskReviewed(s) {
    appWords.markTaskReviewed = s;
  }
  get markTaskReviewed() {
    return appWords.markTaskReviewed ? appWords.markTaskReviewed : 'Mark Task Reviewed';
  }
  set markTaskApproved(s) {
    appWords.markTaskApproved = s;
  }
  get markTaskApproved() {
    return appWords.markTaskApproved ? appWords.markTaskApproved : 'Mark Task Approved';
  }
  set taskInformation(s) {
    appWords.taskInformation = s;
  }
  get taskInformation() {
    return appWords.taskInformation ? appWords.taskInformation : 'Task Information';
  }
  set completion_criteria(s) {
    appWords.completion_criteria = s;
  }
  get completion_criteria() {
    return appWords.completion_criteria ? appWords.completion_criteria : 'Task Completion Criteria';
  }
  set taskAttachments(s) {
    appWords.taskAttachments = s;
  }
  get taskAttachments() {
    return appWords.taskAttachments ? appWords.taskAttachments : 'Task Attachments';
  }
  set taskCompleted(s) {
    appWords.taskCompleted = s;
  }
  get taskCompleted() {
    return appWords.taskCompleted ? appWords.taskCompleted : 'Task Completed';
  }
  set taskName(s) {
    appWords.taskName = s;
  }
  get taskName() {
    return appWords.taskName ? appWords.taskName : 'Task Name';
  }
  set assignedTasks(s) {
    appWords.assignedTasks = s;
  }
  get assignedTasks() {
    return appWords.assignedTasks ? appWords.assignedTasks : 'Assigned Tasks';
  }
  set taskAction(s) {
    appWords.taskAction = s;
  }
  get taskAction() {
    return appWords.taskAction ? appWords.taskAction : 'Task Action';
  }
  set taskHistory(s) {
    appWords.taskHistory = s;
  }
  get taskHistory() {
    return appWords.taskHistory ? appWords.taskHistory : 'Task History';
  }
  set taskDescription(s) {
    appWords.taskDescription = s;
  }
  get taskDescription() {
    return appWords.taskDescription ? appWords.taskDescription : 'Description';
  }
  set noRightsToPage(s) {
    appWords.noRightsToPage = s;
  }
  get noRightsToPage() {
    return appWords.noRightsToPage ? appWords.noRightsToPage : 'We are sorry. You don\'t have adequate user privileges to view this page';
  }
  set alphabetical(s) {
    appWords.alphabetical = s;
  }
  get alphabetical() {
    return appWords.alphabetical ? appWords.alphabetical : 'Alphabetical';
  }
  set byDueDate(s) {
    appWords.byDueDate = s;
  }
  get byDueDate() {
    return appWords.byDueDate ? appWords.byDueDate : 'By Due Date';
  }
  set templatesOnly(s) {
    appWords.templatesOnly = s;
  }
  get templatesOnly() {
    return appWords.templatesOnly ? appWords.templatesOnly : 'Templates Only';
  }
  set allTime(s) {
    appWords.allTime = s;
  }
  get allTime() {
    return appWords.allTime ? appWords.allTime : 'All Time';
  }
  set last30Days(s) {
    appWords.last30Days = s;
  }
  get last30Days() {
    return appWords.last30Days ? appWords.last30Days : 'Last 30 Days';
  }
  set last90Days(s) {
    appWords.last90Days = s;
  }
  get last90Days() {
    return appWords.last90Days ? appWords.last90Days : 'Last 90 Days';
  }
  set action(s) {
    appWords.action = s;
  }
  get action() {
    return appWords.action ? appWords.action : 'Action';
  }
  set filter(s) {
    appWords.filter = s;
  }
  get filter() {
    return appWords.filter ? appWords.filter : 'Filter';
  }
  set filterBy(s) {
    appWords.filterBy = s;
  }
  get filterBy() {
    return appWords.filterBy ? appWords.filterBy : 'Filter By';
  }
  set applyFilter(s) {
    appWords.applyFilter = s;
  }
  get applyFilter() {
    return appWords.applyFilter ? appWords.applyFilter : 'Apply Filter';
  }
  set apply(s) {
    appWords.apply = s;
  }
  get apply() {
    return appWords.apply ? appWords.apply : 'Apply';
  }
  set favorites(s) {
    appWords.favorites = s;
  }
  get favorites() {
    return appWords.favorites ? appWords.favorites : 'Favorites';
  }
  set sortBy(s) {
    appWords.sortBy = s;
  }
  get sortBy() {
    return appWords.sortBy ? appWords.sortBy : 'Sort By';
  }
  set myProfile(s) {
    appWords.myProfile = s;
  }
  get myProfile() {
    return appWords.myProfile ? appWords.myProfile : 'My Profile';
  }
  set logoff(s) {
    appWords.logoff = s;
  }
  get logoff() {
    return appWords.logoff ? appWords.logoff : 'Log Off';
  }
  set comingSoon(s) {
    appWords.comingSoon = s;
  }
  get comingSoon() {
    return appWords.comingSoon ? appWords.comingSoon : 'Coming Soon';
  }
  set poweredBy(s) {
    appWords.poweredBy = s;
  }
  get poweredBy() {
    return appWords.poweredBy ? appWords.poweredBy : 'Powered by Active Oversight';
  }
  set processVerification(s) {
    appWords.processVerification = s;
  }
  get processVerification() {
    return appWords.processVerification ? appWords.processVerification : 'Process Verification Software';
  }
  set privacyPolicy(s) {
    appWords.privacyPolicy = s;
  }
  get privacyPolicy() {
    return appWords.privacyPolicy ? appWords.privacyPolicy : 'Privacy Policy';
  }
  set termsAndConditions(s) {
    appWords.termsAndConditions = s;
  }
  get termsAndConditions() {
    return appWords.termsAndConditions ? appWords.termsAndConditions : 'Terms and Conditions';
  }
  set documents(s) {
    appWords.documents = s;
  }
  get documents() {
    return appWords.documents ? appWords.documents : 'Documents';
  }
  set directories(s) {
    appWords.directories = s;
  }
  get directories() {
    return appWords.directories ? appWords.directories : 'Directory';
  }
  set clear(s) {
    appWords.clear = s;
  }
  get clear() {
    return appWords.clear ? appWords.clear : 'Clear';
  }
  set update(s) {
    appWords.update = s;
  }
  get update() {
    return appWords.update ? appWords.update : 'update';
  }
  set delete(s) {
    appWords.delete = s;
  }
  get delete() {
    return appWords.delete ? appWords.delete : 'delete';
  }
  set create(s) {
    appWords.create = s;
  }
  get create() {
    return appWords.create ? appWords.create : 'create';
  }
  set country(s) {
    appWords.country = s;
  }
  get country() {
    return appWords.country ? appWords.country : 'Country';
  }
  set address(s) {
    appWords.address = s;
  }
  get address() {
    return appWords.address ? appWords.address : 'Address';
  }
  set streetAddress1(s) {
    appWords.streetAddress1 = s;
  }
  get streetAddress1() {
    return appWords.streetAddress1 ? appWords.streetAddress1 : 'Street Address 1';
  }
  set streetAddress2(s) {
    appWords.streetAddress2 = s;
  }
  get streetAddress2() {
    return appWords.streetAddress2 ? appWords.streetAddress2 : 'Street Address 2';
  }
  set city(s) {
    appWords.city = s;
  }
  get city() {
    return appWords.city ? appWords.city : 'City';
  }
  set state(s) {
    appWords.state = s;
  }
  get state() {
    return appWords.state ? appWords.state : 'State';
  }
  set zip(s) {
    appWords.zip = s;
  }
  get zip() {
    return appWords.zip ? appWords.zip : 'Zip Code';
  }
  set latitude(s) {
    appWords.latitude = s;
  }
  get latitude() {
    return appWords.latitude ? appWords.latitude : 'Latitude';
  }
  set longitude(s) {
    appWords.longitude = s;
  }
  get longitude() {
    return appWords.longitude ? appWords.longitude : 'Longitude';
  }
  set firstName(s) {
    appWords.firstName = s;
  }
  get firstName() {
    return appWords.firstName ? appWords.firstName : 'First Name';
  }
  set lastName(s) {
    appWords.lastName = s;
  }
  get lastName() {
    return appWords.lastName ? appWords.lastName : 'Last Name';
  }
  set email(s) {
    appWords.email = s;
  }
  get email() {
    return appWords.email ? appWords.email : 'Email Address';
  }
  set emailExample(s) {		
    appWords.emailExample = s;		
  }		
  get emailExample() {		
    return appWords.emailExample ? appWords.emailExample : 'example@aol.com';		
  }
  set teamLead(s) {
    appWords.teamLead = s;
  }
  get teamLead() {
    return appWords.teamLead ? appWords.teamLead : 'Team Lead';
  }
  set teamName(s) {
    appWords.teamName = s;
  }
  get teamName() {
    return appWords.teamName ? appWords.teamName : 'Team Name';
  }
  set projectsActive(s) {
    appWords.projectsActive = s;
  }
  get projectsActive() {
    return appWords.projectsActive ? appWords.projectsActive : 'Projects: Active | Total';
  }
  set name(s) {
    appWords.name = s;
  }
  get name() {
    return appWords.name ? appWords.name : 'Name';
  }
  set title(s) {
    appWords.name = s;
  }
  get title() {
    return appWords.name ? appWords.name : 'Title';
  }
  set phone(s) {
    appWords.phone = s;
  }
  get phone() {
    return appWords.phone ? appWords.phone : 'Phone';
  }
  set accountContact(s) {
    appWords.accountContact = s;
  }
  get accountContact() {
    return appWords.accountContact ? appWords.accountContact : 'Account Contact';
  }
  set swatchInstructions(s) {
    appWords.swatchInstructions = s;
  }
  get swatchInstructions() {
    return appWords.swatchInstructions ? appWords.swatchInstructions : 'Click color swatch to select color.';
  }
  set accentTheme(s) {
    appWords.accentTheme = s;
  }
  get accentTheme() {
    return appWords.accentTheme ? appWords.accentTheme : 'ACCENT THEME';
  }
  set yes(s) {
    appWords.yes = s;
  }
  get yes() {
    return appWords.yes ? appWords.yes : 'yes';
  }
  set no(s) {
    appWords.no = s;
  }
  get no() {
    return appWords.no ? appWords.no : 'no';
  }
  set admin(s) {
    appWords.admin = s;
  }
  get admin() {
    return appWords.admin ? appWords.admin : 'Admin';
  }
  set enterToSave(s) {
    appWords.enterToSave = s;
  }
  get enterToSave() {
    return appWords.enterToSave ? appWords.enterToSave : 'Hit enter to save';
  }
  set submit(s) {
    appWords.submit = s;
  }
  get submit() {
    return appWords.submit ? appWords.submit : 'submit';
  }
  set fieldName(s) {
    appWords.fieldName = s;
  }
  get fieldName() {
    return appWords.fieldName ? appWords.fieldName : 'Field Name';
  }
  set newValue(s) {
    appWords.newValue = s;
  }
  get newValue() {
    return appWords.newValue ? appWords.newValue : 'New Value';
  }
  set originalValue(s) {
    appWords.originalValue = s;
  }
  get originalValue() {
    return appWords.originalValue ? appWords.originalValue : 'Original Value';
  }
  set editWhiteLabelsFor(s) {
    appWords.editWhiteLabelsFor = s;
  }
  get editWhiteLabelsFor() {
    return appWords.editWhiteLabelsFor ? appWords.editWhiteLabelsFor : 'Edit White Labels for';
  }
  set internalStaff(s) {
    appWords.internalStaff = s;
  }
  get internalStaff() {
    return appWords.internalStaff ? appWords.internalStaff : 'Internal Staff';
  }
  set vendor(s) {
    appWords.vendor = s;
  }
  get vendor() {
    return appWords.vendor ? appWords.vendor : 'Vendor';
  }
  set vendorCompanies(s) {
    appWords.vendorCompanies = s;
  }
  get vendorCompanies() {
    return appWords.vendorCompanies ? appWords.vendorCompanies : 'Vendors';
  }
  set cantEditVendor(s) {
    appWords.cantEditVendor = s;
  }
  get cantEditVendor() {
    return appWords.cantEditVendor ? appWords.cantEditVendor : 'Company Detail page not avialable for vendor companies.';
  }
  set save(s) {
    appWords.save = s;
  }
  get save() {
    return appWords.save ? appWords.save : 'Save';
  }
  set assign(s) {
    appWords.assign = s;
  }
  get assign() {
    return appWords.assign ? appWords.assign : 'Assign';
  }
  set addUser(s) {
    appWords.addUser = s;
  }
  get addUser() {
    return appWords.addUser ? appWords.addUser : 'Add User';
  }
  set users(s) {
    appWords.users = s;
  }
  get users() {
    return appWords.users ? appWords.users : 'Users';
  }
  set info(s) {
    appWords.info = s;
  }
  get info() {
    return appWords.info ? appWords.info : 'Info';
  }
  set security(s) {
    appWords.security = s;
  }
  get security() {
    return appWords.security ? appWords.security : 'Security';
  }
  set promptSendInvite(s) {
    appWords.promptSendInvite = s;
  }
  get promptSendInvite(){
    return appWords.promptSendInvite ? appWords.promptSendInvite : 'Do you want to send an invite now or later?';
  }
  set editUser(s) {
    appWords.editUser = s;
  }
  get editUser() {
    return appWords.editUser ? appWords.editUser : 'Edit';
  }
  set userArchiveQuestion(s) {
    appWords.userArchiveQuestion = s;
  }
  get userArchiveQuestion() {
    return appWords.userArchiveQuestion ? appWords.userArchiveQuestion : 'Are you sure you want to delete this user?';
  }
  set deleteUser(s) {
    appWords.deleteUser = s;
  }
  get deleteUser() {
    return appWords.deleteUser ? appWords.deleteUser : 'Delete';
  }
  set addDirectory(s) {
    appWords.addDirectory = s;
  }
  get addDirectory() {
    return appWords.addDirectory ? appWords.addDirectory : 'Add New Directory';
  }
  set editDirectory(s) {
    appWords.editDirectory = s;
  }
  get editDirectory() {
    return appWords.editDirectory ? appWords.editDirectory : 'Edit';
  }
  set deleteDirectory(s) {
    appWords.deleteDirectory = s;
  }
  get deleteDirectory() {
    return appWords.deleteDirectory ? appWords.deleteDirectory : 'Delete';
  }
  set directoryDeleteQuestion(s) {
    appWords.directoryDeleteQuestion = s;
  }
  get directoryDeleteQuestion() {
    return appWords.directoryDeleteQuestion ? appWords.directoryDeleteQuestion : 'Are you sure you want to delete this directory?';
  }
  set directoryMembers(s) {
    appWords.directoryMembers = s;
  }
  get directoryMembers() {
    return appWords.directoryMembers ? appWords.directoryMembers : 'Directory Members';
  }
  set usePhoto(s) {
    appWords.usePhoto = s;
  }
  get usePhoto() {
    return appWords.usePhoto ? appWords.usePhoto : 'User Photo';
  }
  set cropPhoto(s) {
    appWords.cropPhoto = s;
  }
  get cropPhoto() {
    return appWords.cropPhoto ? appWords.cropPhoto : 'Crop Photo';
  }
  set permission(s) {
    appWords.permission = s;
  }
  get permission() {
    return appWords.permission ? appWords.permission : 'Permission';
  }
  set unassigned(s) {
    appWords.unassigned = s;
  }
  get unassigned() {
    return appWords.unassigned ? appWords.unassigned : 'Unassigned';
  }
  set unknownRole(s) {
    appWords.unknownRole = s;
  }
  get unknownRole() {
    return appWords.unknownRole ? appWords.unknownRole : 'Unknown Role';
  }
  set rotatePhoto(s) {
    appWords.rotatePhoto = s;
  }
  get rotatePhoto() {
    return appWords.rotatePhoto ? appWords.rotatePhoto : 'Rotate Photo';
  }
  set forgotPassword(s) {
    appWords.forgotPassword = s;
  }
  get forgotPassword() {
    return appWords.forgotPassword ? appWords.forgotPassword : 'FORGOT YOUR PASSWORD?';
  }
  set sendForgotPassword(s) {
    appWords.sendForgotPassword = s;
  }
  get sendForgotPassword() {
    return appWords.sendForgotPassword ? appWords.sendForgotPassword : 'Send Email';
  }
  set send(s) {
    appWords.send = s;
  }
  get send() {
    return appWords.send ? appWords.send : 'Send';
  }
  set forgotPasswordMessage(s) {
    appWords.forgotPasswordMessage = s;
  }
  get forgotPasswordMessage() {
    return appWords.forgotPasswordMessage ? appWords.forgotPasswordMessage : 'Please enter the email assosciated with your account to send you a link to reset your password.';
  }
  set dueToday(s) {
    appWords.dueToday = s;
  }
  get dueToday() {
    return appWords.dueToday ? appWords.dueToday : 'Due Today';
  }
  set dueTomorrow(s) {
    appWords.dueTomorrow = s;
  }
  get dueTomorrow() {
    return appWords.dueTomorrow ? appWords.dueTomorrow : 'Due Tomorrow';
  }
  set dueNextWeek(s) {
    appWords.dueNextWeek = s;
  }
  get dueNextWeek() {
    return appWords.dueNextWeek ? appWords.dueNextWeek : 'Due Next Week';
  }
  set pastDue(s) {
    appWords.pastDue = s;
  }
  get pastDue() {
    return appWords.pastDue ? appWords.pastDue : 'Past Due';
  }
  set uniqueId(s) {
    appWords.uniqueId = s;
  }
  get uniqueId() {
    return appWords.uniqueId ? appWords.uniqueId : 'Unique ID';
  }
  set createDate(s) {
    appWords.createDate = s;
  }
  get createDate() {
    return appWords.createDate ? appWords.createDate : 'Create Date';
  }
  set startDate(s) {
    appWords.startDate = s;
  }
  get startDate() {
    return appWords.startDate ? appWords.startDate : 'Start Date';
  }
  set dueDate(s) {
    appWords.dueDate = s;
  }
  get dueDate() {
    return appWords.dueDate ? appWords.dueDate : 'Estimated Due Date';
  }
  set reviewer(s) {
    appWords.reviewer = s;
  }
  get reviewer() {
    return appWords.reviewer ? appWords.reviewer : 'Reviewer';
  }
  set approver(s) {
    appWords.approver = s;
  }
  get approver() {
    return appWords.approver ? appWords.approver : 'Approver';
  }
  set review(s) {
    appWords.review = s;
  }
  get review() {
    return appWords.review ? appWords.review : 'Review';
  }
  set reviewed(s) {
    appWords.reviewed = s;
  }
  get reviewed() {
    return appWords.reviewed ? appWords.reviewed : 'Reviewed';
  }
  set assigned(s) {
    appWords.assigned = s;
  }
  get assigned() {
    return appWords.assigned ? appWords.assigned : 'Assigned';
  }
  set assignedTo(s) {
    appWords.assignedTo = s;
  }
  get assignedTo() {
    return appWords.assignedTo ? appWords.assignedTo : 'Assigned To';
  }
  set addAssignedTo(s) {
    appWords.addAssignedTo = s;
  }
  get addAssignedTo() {
    return appWords.addAssignedTo ? appWords.addAssignedTo : 'Add Assigned To';
  }
  set notifiers(s) {
    appWords.notifiers = s;
  }
  get notifiers() {
    return appWords.notifiers ? appWords.notifiers : 'Notify Upon Completion';
  }
  set noneAssigned(s) {
    appWords.noneAssigned = s;
  }
  get noneAssigned() {
    return appWords.noneAssigned ? appWords.noneAssigned : 'None Assigned';
  }
  set noneSelected(s) {
    appWords.noneSelected = s;
  }
  get noneSelected() {
    return appWords.noneSelected ? appWords.noneSelected : 'None Selected';
  }
  set primaryContractor(s) {
    appWords.primaryContractor = s;
  }
  get primaryContractor() {
    return appWords.primaryContractor ? appWords.primaryContractor : 'Primary Contractor';
  }
  set subContractor(s) {
    appWords.subContractor = s;
  }
  get subContractor() {
    return appWords.subContractor ? appWords.subContractor : 'Sub Contractor';
  }
  set notSet(s) {
    appWords.notSet = s;
  }
  get notSet() {
    return appWords.notSet ? appWords.notSet : 'Not Set';
  }
  set time(s) {
    appWords.time = s;
  }
  get time() {
    return appWords.time ? appWords.time : 'Time';
  }
  set none(s) {
    appWords.none = s;
  }
  get none() {
    return appWords.none ? appWords.none : 'None';
  }
  set unclassified(s) {
    appWords.unclassified = s;
  }
  get unclassified() {
    return appWords.unclassified ? appWords.unclassified : 'Unclassified';
  }
  set id(s) {
    appWords.id = s;
  }
  get id() {
    return appWords.id ? appWords.id : 'Id';
  }
  set lat(s) {
    appWords.lat = s;
  }
  get lat() {
    return appWords.lat ? appWords.lat : 'Lat';
  }
  set lng(s) {
    appWords.lng = s;
  }
  get lng() {
    return appWords.lng ? appWords.lng : 'Lng';
  }
  set password8Characters(s) {
    appWords.password8Characters = s;
  }
  get password8Characters() {
    return appWords.password8Characters ? appWords.password8Characters : 'Password must be 8 characters or more';
  }
  set passwordsMustMatch(s) {
    appWords.passwordsMustMatch = s;
  }
  get passwordsMustMatch() {
    return appWords.passwordsMustMatch ? appWords.passwordsMustMatch : 'Passwords must match';
  }
  set setPassword(s) {
    appWords.setPassword = s;
  }
  get setPassword() {
    return appWords.setPassword ? appWords.setPassword : 'Set Password';
  }
  set createYourPassword(s) {
    appWords.createYourPassword = s;
  }
  get createYourPassword() {
    return appWords.createYourPassword ? appWords.createYourPassword : 'Please enter a password';
  }
  set confirmPassword(s) {
    appWords.confirmPassword = s;
  }
  get confirmPassword() {
    return appWords.confirmPassword ? appWords.confirmPassword : 'Confirm Password';
  }
  set password(s) {
    appWords.password = s;
  }
  get password() {
    return appWords.password ? appWords.password : 'Password';
  }
  set newPassword(s) {
    appWords.newPassword = s;
  }
  get newPassword() {
    return appWords.newPassword ? appWords.newPassword : 'New Password';
  }
  set byStatus(s) {
    appWords.byStatus = s;
  }
  get byStatus() {
    return appWords.byStatus ? appWords.byStatus : 'By Status (In Process First)';
  }
  set complete(s) {
    appWords.complete = s;
  }
  get complete() {
    return appWords.complete ? appWords.complete : 'Upload';
  }
  set edit(s) {
    appWords.edit = s;
  }
  get edit() {
    return appWords.edit ? appWords.edit : 'Edit';
  }
  set copy(s) {
    appWords.copy = s;
  }
  get copy() {
    return appWords.copy ? appWords.copy : 'Copy';
  }
  set notesInstructions(s) {
    appWords.notesInstructions = s;
  }
  get notesInstructions() {
    return appWords.notesInstructions ? appWords.notesInstructions : 'Notes/Instructions';
  }
  set assignment(s) {
    appWords.assignment = s;
  }
  get assignment() {
    return appWords.assignment ? appWords.assignment : 'Assignment';
  }
  set assignments(s) {
    appWords.assignments = s;
  }
  get assignments() {
    return appWords.assignments ? appWords.assignments : 'Assignments';
  } 
  set availableForAssignment(s) {
    appWords.availableForAssignment = s;
  }
  get availableForAssignment() {
    return appWords.availableForAssignment ? appWords.availableForAssignment : 'Available for assignment';
  }
  set completeAndReview(s) {
    appWords.completeAndReview = s;
  }
  get completeAndReview() {
    return appWords.completeAndReview ? appWords.completeAndReview : 'Complete & Review';
  }
  set markedComplete(s) {
    appWords.markedComplete = s;
  }
  get markedComplete() {
    return appWords.markedComplete ? appWords.markedComplete : 'Marked Complete';
  }
  set notCompleted(s) {
    appWords.notCompleted = s;
  }
  get notCompleted() {
    return appWords.notCompleted ? appWords.notCompleted : 'Not Complete';
  }
  set approve(s) {
    appWords.approve = s;
  }
  get approve() {
    return appWords.approve ? appWords.approve : 'Approve';
  }
  set reject(s) {
    appWords.reject = s;
  }
  get reject() {
    return appWords.reject ? appWords.reject : 'Reject';
  }
  set notes(s) {
    appWords.notes = s;
  }
  get notes() {
    return appWords.notes ? appWords.notes : 'Notes';
  }
  set approved(s) {
    appWords.approved = s;
  }
  get approved() {
    return appWords.approved ? appWords.approved : 'Approved';
  }
  set rejected(s) {
    appWords.rejected = s;
  }
  get rejected() {
    return appWords.rejected ? appWords.rejected : 'Rejected';
  }
  set addUnexpectedError(s) {
    appWords.addUnexpectedError = s;
  }
  get addUnexpectedError() {
    return appWords.addUnexpectedError ? appWords.addUnexpectedError : 'An unexpected error occurred while trying to create a ';
  }
  set add(s) {
    appWords.add = s;
  }
  get add() {
    return appWords.add ? appWords.add : 'Add';
  }
  set remove(s) {
    appWords.remove = s;
  }
  get remove() {
    return appWords.remove ? appWords.remove : 'Remove';
  }
  set members(s) {
    appWords.members = s;
  }
  get members() {
    return appWords.members ? appWords.members : 'Members';
  }
  set multipleSelected(s) {
    appWords.multipleSelected = s;
  }
  get multipleSelected() {
    return appWords.multipleSelected ? appWords.multipleSelected : 'Multiple Selected';
  }
  set locationId(s) {
    appWords.locationId = s;
  }
  get locationId() {
    return appWords.locationId ? appWords.locationId : 'Location ID';
  }
  get exportPdf(){
    return appWords.exportPdf ? appWords.exportPdf : 'Export Pdf';
  }

    // Task statuse
  set notStarted(s) {
    appWords.notStarted = s;
  }
  get notStarted() {
    return appWords.notStarted ? appWords.notStarted : 'Not Started';
  }
  set inProgress(s) {
    appWords.inProgress = s;
  }
  get inProgress() {
    return appWords.inProgress ? appWords.inProgress : 'In Progress';
  }
  set ballInCourt(s) {
    appWords.ballInCourt = s;
  }
  get ballInCourt() {
    return appWords.ballInCourt ? appWords.ballInCourt : 'Ball in Court';
  }
  set actionNotRequired(s) {
    appWords.actionNotRequired = s;
  }
  get actionNotRequired() {
    return appWords.actionNotRequired ? appWords.actionNotRequired : 'Action not yet required';
  }
  set awaitingApproval(s) {
    appWords.awaitingApproval = s;
  }
  get awaitingApproval() {
    return appWords.awaitingApproval ? appWords.awaitingApproval : 'Awaiting Approval';
  }
  set pendingApproval(s) {
    appWords.pendingApproval = s;
  }
  get pendingApproval() {
    return appWords.pendingApproval ? appWords.pendingApproval : 'Pending Approval';
  }
  set awaitingReview(s) {
    appWords.awaitingReview = s;
  }
  get awaitingReview() {
    return appWords.awaitingReview ? appWords.awaitingReview : 'Awaiting Review';
  }
  set pendingReview(s) {
    appWords.pendingReview = s;
  }
  get pendingReview() {
    return appWords.pendingReview ? appWords.pendingReview : 'Pending Review';
  }
  set completed(s) {
    appWords.completed = s;
  }
  get completed() {
    return appWords.completed ? appWords.completed : 'Completed';
  }
  set onHold(s) {
    appWords.onHold = s;
  }
  get onHold() {
    return appWords.onHold ? appWords.onHold : 'On Hold';
  }
  set canceled(s) {
    appWords.canceled = s;
  }
  get canceled() {
    return appWords.canceled ? appWords.canceled : 'Canceled';
  }
  set cancel(s) {
    appWords.canceled = s;
  }
  get cancel() {
    return appWords.cancel ? appWords.cancel : 'Cancel';
  }
  set notifications(s) {
    appWords.notifications = s;
  }
  get notifications() {
    return appWords.notifications ? appWords.notifications : 'Notifications';
  }
  set queryDataChanged(s) {
    appWords.queryDataChanged = s;
  }
  get queryDataChanged() {
    return appWords.queryDataChanged ? appWords.queryDataChanged : 'Leaving this page will lose the changes you have made. Do you want to continue?';
  }
  set queryUsersChanged(s) {
    appWords.queryUsersChanged = s;
  }
  get queryUsersChanged() {
    return appWords.queryUsersChanged ? appWords.queryUsersChanged : 'You have added or deleted users. Do you want to cancel?';
  }
  set download(s) {
    appWords.download = s;
  }
  get download() {
    return appWords.download ? appWords.download : 'Export';
  }
  set map(s) {
    appWords.map = s;
  }
  get map() {
    return appWords.map ? appWords.map : 'Map';
  }
  set reports(s) {
    appWords.reports = s;
  }
  get reports() {
    return appWords.reports ? appWords.reports : 'Reports';
  }
  set projectStatus(s) {
    appWords.projectStatus = s;
  }
  get projectStatus() {
    return appWords.projectStatus ? appWords.projectStatus : 'Project Status';
  }
  set allProjectStatuses(s) {
    appWords.allProjectStatuses = s;
  }
  get allProjectStatuses() {
    return appWords.allProjectStatuses ? appWords.allProjectStatuses : '-- All Project Status --';
  }
  set market(s) {
    appWords.market = s;
  }
  get market() {
    return appWords.market ? appWords.market : 'Market';
  }
  set markets(s) {
    appWords.markets = s;
  }
  get markets() {
    return appWords.markets ? appWords.markets : 'Markets';
  }
  set marketSetup(s) {
    appWords.marketSetup = s;
  }
  get marketSetup() {
    return appWords.marketSetup ? appWords.marketSetup : 'Market Setup';
  }
  set activity(s) {
    appWords.activity = s;
  }
  get activity() {
    return appWords.activity ? appWords.activity : 'Activity';
  }
  set activityType(s) {
    appWords.activityType = s;
  }
  get activityType() {
    return appWords.activityType ? appWords.activityType : 'Activity Type';
  }
  set subType(s) {
    appWords.subType = s;
  }
  get subType() {
    return appWords.subType ? appWords.subType : 'Sub-Type';
  }
  set documentType(s) {
    appWords.documentType = s;
  }
  get documentType() {
    return appWords.documentType ? appWords.documentType : 'Document Type';
  }
  set timeStamp(s) {
    appWords.timeStamp = s;
  }
  get timeStamp() {
    return appWords.timeStamp ? appWords.timeStamp : 'Timestamp';
  }
  set description(s) {
    appWords.description = s;
  }
  get description() {
    return appWords.description ? appWords.description : 'Description';
  }  
  set emailNotifications(s) {
    appWords.emailNotifications = s;
  }
  get emailNotifications() {
    return appWords.emailNotifications ? appWords.emailNotifications : 'Email Notifications';
  }
  set receiveEmailNotifications(s) {
    appWords.receiveEmailNotifications = s;
  }
  get receiveEmailNotifications() {
    return appWords.receiveEmailNotifications ? appWords.receiveEmailNotifications : 'Receive Email Notifications';
  }
  set receiveEmailNotificationsDescription(s) {
    appWords.receiveEmailNotificationsDescription = s;
  }
  get receiveEmailNotificationsDescription() {
    return appWords.receiveEmailNotificationsDescription ? appWords.receiveEmailNotificationsDescription : 'Users who are set up to be notified about Projects, Builds, or Tasks will be emailed a notification.';
  }
  set pushNotifications(s) {
    appWords.pushNotifications = s;
  }
  get pushNotifications() {
    return appWords.pushNotifications ? appWords.pushNotifications : 'Push Notifications';
  }
  set receivePushNotifications(s) {
    appWords.receivePushNotifications = s;
  }
  get receivePushNotifications() {
    return appWords.receivePushNotifications ? appWords.receivePushNotifications : 'Receive Push Notifications';
  }
  set receivePushNotificationsDescription(s) {
    appWords.receivePushNotificationsDescription = s;
  }
  get receivePushNotificationsDescription() {
    return appWords.receivePushNotificationsDescription ? appWords.receivePushNotificationsDescription : 'You will receive mobile notifications for items that require you to take action.';
  }
  set projectTemplateNameRequired(s) {
    this.projectTemplateNameRequired = s;
  }
  get projectTemplateNameRequired() {
    return appWords.projectTemplateNameRequired ? appWords.projectTemplateNameRequired : 'Project template name is required';
  }
  set projectTemplateNameExists(s) {
    this.projectTemplateNameExists = s;
  }
  get projectTemplateNameExists() {
    return appWords.projectTemplateNameExists ? appWords.projectTemplateNameExists : 'A project template by that name already exists';
  }
  set markPartialFormAsNA(s) {
    this.markPartialFormAsNA = s;
  }
  get markPartialFormAsNA() {
    return appWords.markPartialFormAsNA ? appWords.markPartialFormAsNA : 'Are you sure you want to N/A this step? One or more fields have been filled out.';
  }
  set support(s) {
    this.support = s;
  }
  get support() {
    return appWords.support ? appWords.support : 'Support';
  }
  set close(s) {
    this.close = s;
  }
  get close() {
    return appWords.close ? appWords.close : 'Okay';
  }
  set done(s) {
    this.done = s;
  }
  get done() {
    return appWords.done ? appWords.done : 'Done';
  }
  set languageOptions(s) {
    this.languageOptions = s;
  }
  get languageOptions() {
    return appWords.languageOptions ? appWords.languageOptions : 'Language Options';
  }
  set applicationInformation(s) {
    this.applicationInformation = s;
  }
  get applicationInformation() {
    return appWords.applicationInformation ? appWords.applicationInformation : 'Application Information';
  }
  set zendeskHelpMessage(s) {
    appWords.zendeskHelpMessage = s;
  }
  get zendeskHelpMessage() {
    return appWords.zendeskHelpMessage ? appWords.zendeskHelpMessage : 'Please provide an explanation of what we can help you with.';
  }
  set zendeskHelpQuestion(s) {
    appWords.zendeskHelpQuestion = s;
  }
  get zendeskHelpQuestion() {
    return appWords.zendeskHelpQuestion ? appWords.zendeskHelpQuestion : 'How can we help you?';
  }
  set zendeskSubject(s) {
    appWords.zendeskSubject = s;
  }
  get zendeskSubject() {
    return appWords.zendeskSubject ? appWords.zendeskSubject : 'Active Oversight Support Request';
  }
  set customerSetup(s) {
    appWords.customerSetup = s;
  }
  get customerSetup() {
    return appWords.customerSetup ? appWords.customerSetup : 'Customer Setup';
  }
  set selectALocation(s) {
    appWords.selectALocation = s;
  }
  get selectALocation() {
    return appWords.selectALocation ? appWords.selectALocation : 'Select a Location';
  }
  set offline(s) {
    appWords.notStarted = s;
  }
  get offline() {
    return appWords.notStarted ? appWords.notStarted : 'Available Offline';
  }
}



// WEBPACK FOOTER //
// ./src/helpers/TextMap.js